<template>
  <div class="p-grid">
    <div class="p-col-4" style="display: flex; align-items: center;">
      <p>On years</p>
    </div>
    <div class="p-col-8" style="vertical-align: middle;">
      <CalendarMultiSelect
          v-model="year"
          :items="['2025', '2026', '2027', '2028', '2029', '2030']"
          placeholder="Every year"
          :columns="6"
          :disabled="!selectedAlarmPoint"
      />
    </div>


    <div class="p-col-4 stripedBg" style="display: flex; align-items: center;">
      <p>On months</p>
    </div>
    <div class="p-col-8 stripedBg" style="vertical-align: middle;">
      <CalendarMultiSelect
          v-model="month"
          :items="['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']"
          placeholder="Every month"
          :columns="4"
          :disabled="!selectedAlarmPoint"
      />
    </div>

    <div
        style="display: flex; flex-direction: column; width: 100%; border: 1px solid #ccc; margin: 6px 0; border-radius: 6px;">
      <div style="display: flex;">
        <div class="p-col-4" style="display: flex; align-items: center;">
          <p>On days of the week</p>
        </div>
        <div class="p-col-8" style="vertical-align: middle;">
          <CalendarMultiSelect
              v-model="dayOfWeek"
              :items="['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']"
              placeholder="Every day of the week"
              :columns="5"
              :disabled="!selectedAlarmPoint || dayOfMonth.length"
              :allowInput="false"
          />
        </div>
      </div>

      <divider>or</divider>

      <div style="display: flex;">
        <div class="p-col-4" style="display: flex; align-items: center;">
          <p>On days of the months</p>
        </div>
        <div class="p-col-8" style="vertical-align: middle;">
          <CalendarMultiSelect v-model="dayOfMonth" :items="Array.from({ length: 31 }, (_, i) => i + 1)"
                               placeholder="Every day of the month"
                               :columns="7"
                               :disabled="!selectedAlarmPoint || dayOfWeek.length" :allowInput="true"
                               :withTooltip="true"/>
        </div>
      </div>
    </div>

    <div class="p-col-4 stripedBg" style="display: flex; align-items: center;">
      <p>At specific hours</p>
    </div>
    <div class="p-col-8 stripedBg" style="vertical-align: middle;">
      <CalendarMultiSelect v-model="hour" :columns="8"
                           :items="Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'))"
                           placeholder="Every hour" :disabled="!selectedAlarmPoint" :allowInput="true"
                           :withTooltip="true"/>
    </div>

    <div class="p-col-4 " style="display: flex; align-items: center;">
      <p>At specific minutes</p>
    </div>
    <div class="p-col-8" style="vertical-align: middle;">
      <CalendarMultiSelect
          v-model="minute"
          :columns="8"
          :items="Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0'))"
          placeholder="Every minute"
          :disabled="!selectedAlarmPoint"
          :allowInput="true"
          :withTooltip="true"
      />

    </div>

    <div class="schedule-inline" v-html="formattedSchedule"></div>
  </div>

</template>

<script>
import CalendarMultiSelect from "@/components/CalendarMultiSelect.vue";

export default {
  name: "CronEditor",
  props: {
    selectedAlarmPoint: {
      type: String,
      default: '',
    }
  },
  components: {
    CalendarMultiSelect,
  },
  data() {
    return {
      interval: "",
      second: [],
      minute: [],
      hour: [],
      dayOfMonth: [],
      month: [],
      dayOfWeek: [],
      year: [],
      years: ["Every year", "2025", "2026", "2027", "2028", "2029", "2030"],
      intervals: ["year", "month", "week", "day", "hour", "minute"],
      months: [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ],
      weekdays: {
        0: "Monday",
        1: "Tuesday",
        2: "Wednesday",
        3: "Thursday",
        4: "Friday",
        5: "Saturday",
        6: "Sunday"
      },
      weekdaysShort: {
        0: "MON",
        1: "TUE",
        2: "WED",
        3: "THU",
        4: "FRI",
        5: "SAT",
        6: "SUN"
      },
    };
  },
  watch: {
    interval() {
      this.second = [];
      this.minute = [];
      this.hour = [];
      this.dayOfMonth = [];
      this.month = [];
      this.dayOfWeek = [];
    },
  },
  methods: {
    getCronString() {
      const parseNumbers = (arr) => arr.map((v) => Number(v)).filter((v) => !isNaN(v));

      const monthValues = this.month.map(m => this.months.indexOf(m) + 1).filter(v => v > 0);

      const dayOfWeekValues = this.dayOfWeek.map(d => (d + 1) % 7);

      const yearValues = parseNumbers(this.year);

      const secondStr = "0";

      const minuteStr = this.toCompactCron(parseNumbers(this.minute), this.minuteOptions.length);
      const hourStr = this.toCompactCron(parseNumbers(this.hour), this.hourOptions.length);
      const dayOfMonthStr = this.dayOfMonth.length
          ? this.toCompactCron(parseNumbers(this.dayOfMonth), this.dayOfMonthOptions.length)
          : "*";

      const monthStr = monthValues.length
          ? this.toCompactCron(monthValues, this.monthOptions.length)
          : "*";

      const dayOfWeekStr = (!this.dayOfMonth.length && dayOfWeekValues.length)
          ? this.toCompactCron(dayOfWeekValues, this.dayOfWeekOptions.length)
          : "*";

      const yearStr = yearValues.length
          ? this.toCompactCron(yearValues, this.years.length - 1)
          : "*";

      return `${secondStr} ${minuteStr} ${hourStr} ${dayOfMonthStr} ${monthStr} ${dayOfWeekStr} ${yearStr}`;
    },
    pad(v) {
      return String(v).padStart(2, '0');
    },
    toCompactCron(arr, fullLength) {
      if (!arr || arr.length === 0) return "*";
      if (arr.length === fullLength) return "*";

      const sorted = [...arr].sort((a, b) => a - b);

      const ranges = [];
      let start = sorted[0];
      let end = start;

      for (let i = 1; i <= sorted.length; i++) {
        const current = sorted[i];
        if (current === end + 1) {
          end = current;
        } else {
          if (start === end) {
            ranges.push(String(start));
          } else {
            ranges.push(`${start}-${end}`);
          }
          start = current;
          end = current;
        }
      }

      return ranges.join(",");
    },
    toCompactDaysOfWeek(arr, fullLength) {
      if (!arr || arr.length === 0) return "*";
      if (arr.length === fullLength) return "*";

      const sorted = [...arr].sort((a, b) => a - b);

      const ranges = [];
      let start = sorted[0];
      let end = start;

      const pushRange = (s, e) => {
        if (s === e) {
          ranges.push(this.weekdaysShort[s]);
        } else {
          ranges.push(`${this.weekdaysShort[s]}-${this.weekdaysShort[e]}`);
        }
      };

      for (let i = 1; i <= sorted.length; i++) {
        const current = sorted[i];
        if (current === end + 1) {
          end = current;
        } else {
          pushRange(start, end);
          start = current;
          end = current;
        }
      }

      return ranges.join(",");
    },
  },
  computed: {
    monthOptions() {
      const fullMonths = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      return fullMonths.map((m, i) => ({label: m, value: i + 1}));
    },
    dayOfMonthOptions() {
      return Array.from({length: 31}, (_, i) => ({
        label: (i + 1).toString(),
        value: i + 1
      }));
    },
    dayOfWeekOptions() {
      return Object.entries(this.weekdays).map(([val, day]) => ({
        label: day,
        value: Number(val)
      }));
    },
    hourOptions() {
      return Array.from({length: 24}, (_, i) => ({
        label: this.pad(i),
        value: i
      }));
    },
    minuteOptions() {
      return Array.from({length: 60}, (_, i) => ({
        label: this.pad(i),
        value: i
      }));
    },
    formattedSchedule() {
      const parts = [];

      function sortByReference(arr, referenceArray) {
        return [...arr].sort((a, b) => referenceArray.indexOf(a) - referenceArray.indexOf(b));
      }

      function label(single, plural, values) {
        return values.length === 1 ? single : plural;
      }

      if (this.year.length) {
        const sortedYears = [...this.year].map(Number).sort((a, b) => a - b);
        parts.push(`<span class="schedule-part"><span class="label">${label('On year:', 'On years:', sortedYears)}</span> <strong>${sortedYears.join(', ')}</strong></span>`);
      }

      if (this.month.length) {
        const sortedMonths = sortByReference(this.month, this.months);
        parts.push(`<span class="schedule-part"><span class="label">${label('On month:', 'On months:', sortedMonths)}</span> <strong>${sortedMonths.join(', ')}</strong></span>`);
      }

      if (this.dayOfMonth.length) {
        const sortedDays = [...this.dayOfMonth].map(Number).sort((a, b) => a - b);
        parts.push(`<span class="schedule-part"><span class="label">${label('On day of the month:', 'On days of the month:', sortedDays)}</span> <strong>${sortedDays.join(', ')}</strong></span>`);
      } else if (this.dayOfWeek.length) {
        const weekdayOrder = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
        const sortedDaysOfWeek = sortByReference(this.dayOfWeek, weekdayOrder);
        parts.push(`<span class="schedule-part"><span class="label">${label('On day of the week:', 'On days of the week:', sortedDaysOfWeek)}</span> <strong>${sortedDaysOfWeek.join(', ')}</strong></span>`);
      }

      if (this.hour.length) {
        const sortedHours = [...this.hour].map(Number).sort((a, b) => a - b).map(h => this.pad(h));
        parts.push(`<span class="schedule-part"><span class="label">${label('At hour:', 'At hours:', sortedHours)}</span> <strong>${sortedHours.join(', ')}</strong></span>`);
      }

      if (this.minute.length) {
        const sortedMinutes = [...this.minute].map(Number).sort((a, b) => a - b).map(m => this.pad(m));
        parts.push(`<span class="schedule-part"><span class="label">${label('At minute:', 'At minutes:', sortedMinutes)}</span> <strong>${sortedMinutes.join(', ')}</strong></span>`);
      }

      return parts.length
          ? parts.join('<span class="separator">·</span>')
          : '';
    }
  },
};
</script>

<style lang="scss" scoped>
.cron-editor-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 0.95rem;
  user-select: none;
}

.label {
  font-weight: 600;
  width: 90px;
  user-select: none;
}

.separator {
  margin: 0 0.2rem;
  user-select: none;
}

.cron-label {
  font-weight: 600;
  margin-bottom: 4px;
}

.row {
  display: flex;
  justify-content: flex-start;
  gap: 20px;
  margin: 2px 0;
  align-items: center;
}

.value {
  color: #689F38;
}


</style>

<style>
.schedule-inline {
  margin-top: 16px;
  font-size: 0.95rem;
  line-height: 1.4;
  color: #333;
  word-break: break-word;
}

.schedule-part {
  display: inline-block;
  white-space: normal;
  margin-right: 8px;
  max-width: 100%;
}

.schedule-inline span.label {
  font-weight: 600;
  color: #689F38;
  cursor: default;
  padding-right: 4px;
  user-select: none;
  white-space: nowrap;
}

.schedule-inline span.separator {
  color: #999;
  user-select: none;
  padding: 0 6px;
}

</style>
